// extracted by mini-css-extract-plugin
export default {"loadingContainer":"src-feature-user-__email-verification_loadingContainer","loading":"src-feature-user-__email-verification_loading"};